/**
 * Function called to allow handler to process the  now-resolved-props before they are assigned to the component/host
 * @name ProcessNowResolvedPropsFn
 * @function
 * @param {{host:SeismicElement, rawResolvedProps:obj, propertyKeys}} opts
 */

/**
 * Function called to cleanup any subscriptions or listeners when the host is disconnected
 * @name DisconnectNowResolvedPropsCallbacksFn
 * @function
 * @param {SeismicElement} host
 */

/**
 * Function provided by component that will initiate the property changes
 * @name ChangeCallbackFn
 * @function
 * @param {object} propertiesToUpdate
 */

/**
 * Function called to create any subscriptions or listeners when the host is connected
 * @name ConnectNowResolvedPropsCallbacksFn
 * @function
 * @param {SeismicElement} host
 * @param {ChangeCallbackFn} changeCallback
 */

/**
 * @typedef NowResolvedPropsHandler
 * @type {object}
 * @property {ProcessNowResolvedPropsFn} processNowResolvedProps
 * @property {DisconnectNowResolvedPropsCallbacksFn} disconnectNowResolvedPropsCallbacks
 * @property {ConnectNowResolvedPropsCallbacksFn} connectNowResolvedPropsCallbacks
 */

/** @type {NowResolvedPropsHandler|null} */
let nowResolvedPropsHandler = null;

export function processNowResolvedProps({host, rawResolvedProps, propertyKeys}) {
	if (!nowResolvedPropsHandler) return {};

	if (
		nowResolvedPropsHandler.processNowResolvedProps === undefined ||
		typeof nowResolvedPropsHandler.processNowResolvedProps !== 'function'
	) {
		return {};
	}
	return nowResolvedPropsHandler.processNowResolvedProps({host, rawResolvedProps, propertyKeys});
}

export function disconnectNowResolvedPropsCallbacks(host) {
	if (!nowResolvedPropsHandler) return;

	if (
		nowResolvedPropsHandler.disconnectNowResolvedPropsCallbacks === undefined ||
		typeof nowResolvedPropsHandler.disconnectNowResolvedPropsCallbacks !== 'function'
	) {
		return;
	}
	nowResolvedPropsHandler.disconnectNowResolvedPropsCallbacks(host);
}

export function connectNowResolvedPropsCallbacks(host, changeCallback) {
	if (!nowResolvedPropsHandler) return;

	if (
		nowResolvedPropsHandler.connectNowResolvedPropsCallbacks === undefined ||
		typeof nowResolvedPropsHandler.connectNowResolvedPropsCallbacks !== 'function'
	) {
		return;
	}
	nowResolvedPropsHandler.connectNowResolvedPropsCallbacks(host, changeCallback);
}

export function clearNowResolvedPropsHandler() {
	nowResolvedPropsHandler = null;
}

/**
 * Registers a nowResolvedPropsHandler for resolving dynamic properties.
 * @param {NowResolvedPropsHandler} handler
 */
export function registerNowResolvedPropsHandler(handler) {
	nowResolvedPropsHandler = handler;
}
